export default class ScrollBar extends Phaser.GameObjects.Container {
    constructor(scene, x, y, height = 800) {
        super(scene, x, y, []);
        this.scene = scene;
        scene.add.existing(this);

        // Ajout barre
        this.barreScroll = this.scene.add.rexRoundRectangle(0, 0, 8, 216, 4, 0xDFDFE3).setOrigin(0.5, 0);
        this.add(this.barreScroll);

        this.setSize(this.barreScroll.width, height);

    }
}